__webpack_require__.p = "/crypto-currency/";